export const SCAN_TO_VERIFY_SUBMIT_VERIFICATION = 'SCAN_TO_VERIFY_SUBMIT_VERIFICATION';
export const submitVerification = () => ({
  type: SCAN_TO_VERIFY_SUBMIT_VERIFICATION,
});

export const SET_VERIFICATION_STATUS_REQUEST = 'SET_VERIFICATION_STATUS_REQUEST';
export const setVerificationStatusRequest = (verificationStatus) => ({
  type: SET_VERIFICATION_STATUS_REQUEST,
  verificationStatus,
});

export const SET_VERIFICATION_STATUS_SUCCESS = 'SET_VERIFICATION_STATUS_SUCCESS';
export const setVerificationStatusSuccess = (verificationStatus) => ({
  type: SET_VERIFICATION_STATUS_SUCCESS,
  verificationStatus,
});

export const SET_VERIFICATION_STATUS_FAILURE = 'SET_VERIFICATION_STATUS_FAILURE';
export const setVerificationStatusFailure = (errors) => ({
  type: SET_VERIFICATION_STATUS_FAILURE,
  errors,
});

export const EDIT_VERIFIED_ITEMS = 'EDIT_VERIFIED_ITEMS';
export const editVerifiedItems = () => ({
  type: EDIT_VERIFIED_ITEMS,
});
